import { isValidTenantSlug } from '@/common/tenant-utils';
import {
  MAX_REMEMBERED_TENANTS,
  REMEMBERED_TENANTS_STORAGE_KEY,
} from '@/features/remembered-tenants/constants';
import { logError } from '@/utils/error-logger';

export function loadRememberedTenants() {
  try {
    const stored: unknown = JSON.parse(
      localStorage.getItem(REMEMBERED_TENANTS_STORAGE_KEY) ?? '[]'
    );

    return Array.isArray(stored) ? stored.filter(isValidTenantSlug) : [];
  } catch {
    return [];
  }
}

function saveRememberedTenants(tenants: string[]) {
  try {
    localStorage.setItem(
      REMEMBERED_TENANTS_STORAGE_KEY,
      JSON.stringify(tenants)
    );
  } catch (error) {
    logError(error, 'rememberedTenants:save');
  }
}

export function rememberTenant(tenant: string) {
  const others = loadRememberedTenants().filter(
    remembered => remembered !== tenant
  );
  saveRememberedTenants([tenant, ...others].slice(0, MAX_REMEMBERED_TENANTS));
}

export function forgetTenant(tenant: string) {
  const remaining = loadRememberedTenants().filter(
    remembered => remembered !== tenant
  );
  saveRememberedTenants(remaining);

  return remaining;
}
